import React from 'react';
import { Image } from 'expo-image';
import { isWeb } from './landingTokens';

// Reuse the transparent, role-specific artwork from the seeded bot catalog.
export const PIXEL_ART = {
  creative: require('@/assets/images/bots/visual-prompt-creative-director.png'),
  game: require('@/assets/images/bots/stem-first-principles-explainer.png'),
  developer: require('@/assets/images/bots/full-stack-software-architect.png'),
  writer: require('@/assets/images/bots/executive-ghostwriter-speechwriter.png'),
};

export function PixelAvatar({ source, size, priority = 'normal' }) {
  return (
    <Image
      source={source}
      contentFit="contain"
      priority={priority}
      accessible={false}
      aria-hidden={isWeb ? true : undefined}
      style={{ width: size, height: size, flexShrink: 0 }}
    />
  );
}
